// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.memory-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  border: 1px solid #dce5eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}
.memory-item:hover {
  border-color: #afc8db;
  box-shadow: 0 5px 16px #344d6310;
}
.memory-photo-button {
  display: block;
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  aspect-ratio: 4 / 3;
  padding: 0;
  border: 0;
  background: #edf1f3;
  cursor: zoom-in;
  overflow: hidden;
}
.memory-photo {
  display: block;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.memory-zoom {
  position: absolute;
  bottom: 12px;
  right: 12px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ffffffed;
  color: #456a85;
  opacity: 0;
  transition: opacity 0.15s;
}
.memory-photo-button:hover .memory-zoom,
.memory-photo-button:focus-visible .memory-zoom {
  opacity: 1;
}
.memory-card-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;
  padding: 22px;
  color: inherit;
  text-decoration: none;
  min-width: 0;
}
.memory-primary-text,
.memory-secondary-text {
  margin: 0;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.memory-primary-text {
  color: #52616a;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.65;
  -webkit-line-clamp: 10;
}
.memory-secondary-text {
  font-size: 18px;
  line-height: 1.45;
  font-weight: 600;
  -webkit-line-clamp: 4;
}
.memory-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding-top: 18px;
  margin-top: auto;
  color: #677982;
  font-size: 13px;
  border-top: 1px solid #dce5eb;
}
.memory-author {
  min-width: 0;
  overflow-wrap: anywhere;
}
.memory-comment-count {
  display: flex;
  gap: 5px;
  align-items: center;
  flex-shrink: 0;
}
.memory-card-no-text {
  padding-block: 14px;
}
.memory-card-no-text .memory-card-footer {
  padding: 0;
  border: 0;
}
.memory-item-quotation {
  background: #eaf3fa;
  border-color: #d2e2ef;
}
.memory-item-quotation .memory-card-text {
  padding: 30px 26px 22px;
  min-height: 340px;
}
.memory-item-quotation .memory-primary-text {
  color: #416f9d;
  font-size: 23px;
  line-height: 1.5;
  -webkit-line-clamp: 12;
}
.memory-type-symbol {
  color: #86aac8;
}
.memory-item-story {
  background: #fdf1ee;
  border-color: #efddd8;
}
.memory-item-story .memory-card-text {
  padding-top: 30px;
  min-height: 340px;
}
.memory-item-story .memory-primary-text {
  color: #6c5752;
  -webkit-line-clamp: 13;
}
.memory-kind {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #a96759;
}
.memory-grid.list {
  grid-template-columns: minmax(0, 1fr);
  max-width: 850px;
  margin-inline: auto;
}
.memory-grid.list .memory-item-image {
  display: grid;
  grid-template-columns: minmax(180px, 35%) minmax(0, 1fr);
}
.memory-grid.list .memory-photo-button {
  height: 100%;
  min-height: 220px;
  aspect-ratio: auto;
}
.memory-grid.list .memory-card-text {
  min-height: 220px;
}
@media (max-width: 600px) {
  .memory-grid.list .memory-item-image {
    display: flex;
  }
  .memory-grid.list .memory-photo-button {
    aspect-ratio: 4 / 3;
    height: auto;
  }
  .memory-grid.list .memory-card-text {
    min-height: 0;
  }
}
.memory-hosted-video {
  position: relative;
  display: grid;
  place-items: center;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #25332e;
  color: #fff;
}
.memory-hosted-video img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.memory-hosted-video > span {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}
.memory-hosted-video svg {
  padding: 13px;
  box-sizing: content-box;
  border-radius: 50%;
  background: #14251cb3;
}
`, "",{"version":3,"sources":["webpack://./src/Memory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB;;oBAEkB;AACpB;AACA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,yBAAyB;AAC3B;AACA;;EAEE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;AACA;;EAEE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":[".memory-item {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: 100%;\n  border: 1px solid #dce5eb;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n.memory-item:hover {\n  border-color: #afc8db;\n  box-shadow: 0 5px 16px #344d6310;\n}\n.memory-photo-button {\n  display: block;\n  position: relative;\n  flex: 0 0 auto;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  padding: 0;\n  border: 0;\n  background: #edf1f3;\n  cursor: zoom-in;\n  overflow: hidden;\n}\n.memory-photo {\n  display: block;\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.memory-zoom {\n  position: absolute;\n  bottom: 12px;\n  right: 12px;\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #ffffffed;\n  color: #456a85;\n  opacity: 0;\n  transition: opacity 0.15s;\n}\n.memory-photo-button:hover .memory-zoom,\n.memory-photo-button:focus-visible .memory-zoom {\n  opacity: 1;\n}\n.memory-card-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 12px;\n  padding: 22px;\n  color: inherit;\n  text-decoration: none;\n  min-width: 0;\n}\n.memory-primary-text,\n.memory-secondary-text {\n  margin: 0;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.memory-primary-text {\n  color: #52616a;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.65;\n  -webkit-line-clamp: 10;\n}\n.memory-secondary-text {\n  font-size: 18px;\n  line-height: 1.45;\n  font-weight: 600;\n  -webkit-line-clamp: 4;\n}\n.memory-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding-top: 18px;\n  margin-top: auto;\n  color: #677982;\n  font-size: 13px;\n  border-top: 1px solid #dce5eb;\n}\n.memory-author {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.memory-comment-count {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  flex-shrink: 0;\n}\n.memory-card-no-text {\n  padding-block: 14px;\n}\n.memory-card-no-text .memory-card-footer {\n  padding: 0;\n  border: 0;\n}\n.memory-item-quotation {\n  background: #eaf3fa;\n  border-color: #d2e2ef;\n}\n.memory-item-quotation .memory-card-text {\n  padding: 30px 26px 22px;\n  min-height: 340px;\n}\n.memory-item-quotation .memory-primary-text {\n  color: #416f9d;\n  font-size: 23px;\n  line-height: 1.5;\n  -webkit-line-clamp: 12;\n}\n.memory-type-symbol {\n  color: #86aac8;\n}\n.memory-item-story {\n  background: #fdf1ee;\n  border-color: #efddd8;\n}\n.memory-item-story .memory-card-text {\n  padding-top: 30px;\n  min-height: 340px;\n}\n.memory-item-story .memory-primary-text {\n  color: #6c5752;\n  -webkit-line-clamp: 13;\n}\n.memory-kind {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #a96759;\n}\n.memory-grid.list {\n  grid-template-columns: minmax(0, 1fr);\n  max-width: 850px;\n  margin-inline: auto;\n}\n.memory-grid.list .memory-item-image {\n  display: grid;\n  grid-template-columns: minmax(180px, 35%) minmax(0, 1fr);\n}\n.memory-grid.list .memory-photo-button {\n  height: 100%;\n  min-height: 220px;\n  aspect-ratio: auto;\n}\n.memory-grid.list .memory-card-text {\n  min-height: 220px;\n}\n@media (max-width: 600px) {\n  .memory-grid.list .memory-item-image {\n    display: flex;\n  }\n  .memory-grid.list .memory-photo-button {\n    aspect-ratio: 4 / 3;\n    height: auto;\n  }\n  .memory-grid.list .memory-card-text {\n    min-height: 0;\n  }\n}\n.memory-hosted-video {\n  position: relative;\n  display: grid;\n  place-items: center;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  background: #25332e;\n  color: #fff;\n}\n.memory-hosted-video img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.memory-hosted-video > span {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n}\n.memory-hosted-video svg {\n  padding: 13px;\n  box-sizing: content-box;\n  border-radius: 50%;\n  background: #14251cb3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
